import type { ReactNode } from 'react'
import { BodyWrapper, SectionWrapper } from './style'

interface BodyProps {
  top?: ReactNode
  bottom?: ReactNode
  sectionClassName?: string
}

const Body = ({ top, bottom, sectionClassName }: BodyProps) => {
  return (
    <BodyWrapper>
      <SectionWrapper className={sectionClassName}>{top}</SectionWrapper>
    </BodyWrapper>
  )
}

export default Body
